import { connectNotificationSocket } from "@js/websockets/notificationSocket.js";
import { showNotification } from "@js/components/notification.js";

document.addEventListener("DOMContentLoaded", () => {
  connectNotificationSocket(showNotification);
});
